import { useMap } from "@vis.gl/react-google-maps";
import { useEffect, useRef } from "react";

export interface PolylineProps {
  enabled?: boolean;
  geodesic?: boolean;
  icons?: google.maps.IconSequence[];
  path: { lat: number; lng: number }[] | google.maps.LatLng[];
  strokeColor?: string;
  strokeOpacity?: number;
  strokeWeight?: number;
}

export function Polyline({
  path,
  strokeColor = "#1F2937",
  strokeOpacity = 0.8,
  strokeWeight = 3,
  geodesic = true,
  icons,
  enabled = true,
}: PolylineProps) {
  const map = useMap();
  const polylineRef = useRef<google.maps.Polyline | null>(null);

  useEffect(() => {
    if (!map || !enabled || path.length < 2) {
      if (polylineRef.current) {
        polylineRef.current.setMap(null);
        polylineRef.current = null;
      }
      return;
    }

    if (polylineRef.current) {
      polylineRef.current.setMap(null);
    }

    const normalizedPath = path.map((point) => {
      if (point instanceof google.maps.LatLng) {
        return { lat: point.lat(), lng: point.lng() };
      }
      return point;
    });

    const polyline = new google.maps.Polyline({
      geodesic,
      icons,
      path: normalizedPath,
      strokeColor,
      strokeOpacity,
      strokeWeight,
    });

    polyline.setMap(map);
    polylineRef.current = polyline;

    return () => {
      if (polylineRef.current) {
        polylineRef.current.setMap(null);
      }
    };
  }, [
    map,
    path,
    strokeColor,
    strokeOpacity,
    strokeWeight,
    geodesic,
    icons,
    enabled,
  ]);

  return null;
}
